<template>
  <div class="landing-final-cta">
    <div class="landing-final-cta__container">
      <h2
        class="landing-final-cta__title"
        v-html="titleWithMobileBreak"
      />

      <BaseButton
        class="landing-final-cta__button"
        @click="handleCTAButtonClick"
      >
        {{ ctaBtnTitle }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import BaseButton from '@shared/components/BaseButton.vue'

const { t } = useI18n()

defineProps({
  ctaBtnTitle: {
    type: String,
    default: '',
  },
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
})

const titleWithMobileBreak = computed(() =>
  t('b2b__landing_page__final_cta__title').replace(
    ', ',
    ',<span class="landing-final-cta__mobile-break"></span> ',
  ),
)
</script>

<style lang="scss" scoped>
.landing-final-cta {
  background-color: $kds-color-background-interactive-accent;
  padding: 80px 10px;

  &__container {
    @extend %container;
    @include flex-container(column, center, md, center);
    margin: 0 auto;
  }

  &__title {
    @include kds-typography-display-small;
    font-weight: $kds-typography-font-weight-medium;
    color: $kds-color-text-primary-inverse;
    text-align: center;
    margin: 0 0 $kds-space-2x;

    @include media-up(md) {
      @include kds-typography-display-medium;
      font-weight: $kds-typography-font-weight-medium;
      white-space: nowrap;
    }
  }

  &__button {
    width: auto;
  }

  &__mobile-break {
    display: block;

    @include media-up(md) {
      display: inline;
    }
  }
}
</style>
